module.exports = __webpack_public_path__ + "img/gift3-hd-be.c9184d89.jpg";